import { Disclosure as HeadlessDisclosure } from "@headlessui/react";
import { ReactNode } from "react";

// TODO Find a way to dynamically animate collapsing of the body height
// TODO compound components
export const AccordionBody = ({ children }: { children?: ReactNode }) => (
  <HeadlessDisclosure.Panel as="div">{children}</HeadlessDisclosure.Panel>
);
